/**
 * @param {number} period
 * @param {number[]} allowedPeriods
 * @returns {boolean}
 */
const isPeriodAllowed = (period, allowedPeriods) => {
  if (typeof period !== "number" || Number.isNaN(period)) {
    return false;
  }

  return Array.isArray(allowedPeriods) && allowedPeriods.includes(period);
};

export default isPeriodAllowed;
